import React, { useCallback, useRef } from 'react';
import { Container } from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2';
import { ContainerButton, Input, TextTitle, Title } from '../../../../../styles/global';
import Panel from '../../../../../components/Panel';
import { FormHandles } from '@unform/core';
import { Form } from '@unform/web';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSave, faX } from '@fortawesome/free-solid-svg-icons';
import useProcessoTipos from '../../../../../actions/cruds/Processos/useProcessoTipos';

const TipoProcessoCreate: React.FC = () => {
    const { createTipoProcesso } = useProcessoTipos();

    const formRef = useRef<FormHandles>(null);

    const handleSubmit = useCallback(
        async (data: object) => {
            try {
                console.log("data", data);
                createTipoProcesso(data);
            } catch (err) {
                console.log(err);
            }
        }, [],
    );

    return (
        <Container>
            <Title>
                <span>Cadastrar Tipo do processo</span>
            </Title>

            <Form id="form1" ref={formRef} onSubmit={handleSubmit} >
                <Panel titulo='Tipo do processo'>
                    <Grid container spacing={6}>
                        <Grid xs={12}>
                            <TextTitle>Nome:</TextTitle>
                            <Input type="text" name='nome' required />
                        </Grid>
                    </Grid>
                </Panel>
                <ContainerButton>
                    <Link to="/processos/cadastros/tipoprocesso">
                        <button><FontAwesomeIcon icon={faX} size="1x" /> Cancelar</button>
                    </Link>
                    <button type="submit" form="form1"><FontAwesomeIcon icon={faSave} /> Salvar</button>
                </ContainerButton>
            </Form>
        </Container>
    );
};

export default TipoProcessoCreate;